var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isPDF)?_c('img',{attrs:{"src":_vm.item.file,"title":_vm.item.name,"width":_vm.width,"height":_vm.height}}):_vm._e(),(_vm.isPDF)?_c('iframe',{attrs:{"src":_vm.item.file,"width":_vm.width,"height":_vm.height}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }